import { Modal } from "@mui/material";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomTextarea from "../../../../components/CustomTextarea";
import { cancelTalent } from "reducers/companyTalent";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSnackbar } from "notistack";
import CustomToast from "../../../../components/CustomToast";
import i18n from "utils/i18n";

const CancelTalentModal = ({ open, onClose }: any) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { selectedTalent } = useSelector((state: any) => state.companyTalent);
  const [cancelReason, setCancelReason] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const showCustomToast = ({title="メッセージ", message, variant="success", type="normal"}) => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast
          title={title}
          message={message}
          variant={variant}
          snackbarKey={key}
          closeSnackbar={closeSnackbar}
          type={type}
        />
      ),
    });
  }

  const handleCancelTalent = () => {
    if(!selectedTalent?.id) {
        return
    }
    setIsSaving(true)

    const data = {
      id: selectedTalent?.id,
      cancel_reason: cancelReason
    }
    dispatch(cancelTalent({requestBody: data}));
    onClose()
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="bg-white rounded-2xl min-w-[424px] max-w-[424px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] outline-none overflow-y-auto custom-scrollbar">
        <div className="p-6 bg-[#FDE9E9]">
          <div className="flex items-center gap-[0.625rem] mb-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M12.6 18.2H15.4V21H12.6V18.2ZM12.6 7H15.4V15.4H12.6V7ZM13.986 0C6.258 0 0 6.272 0 14C0 21.728 6.258 28 13.986 28C21.728 28 28 21.728 28 14C28 6.272 21.728 0 13.986 0ZM14 25.2C7.812 25.2 2.8 20.188 2.8 14C2.8 7.812 7.812 2.8 14 2.8C20.188 2.8 25.2 7.812 25.2 14C25.2 20.188 20.188 25.2 14 25.2Z" fill="#F00C0C"/>
            </svg>
            <h2 className="text-2xl leading-[2.25rem] font-bold alu-text-base-2">退会手続き</h2>
          </div>
          <h2 className="text-sm alu-text-base-2">{selectedTalent?.talent?.last_name} {selectedTalent?.talent?.first_name}さんの退会手続きを行います。<br/>退会すると元に戻すことはできません。よろしいですか？</h2>
        </div>

        <div className="p-6">
            <label className="block text-sm font-bold alu-text-base-2 mb-2">退会理由 <span className="text-[#F33D62]">*</span></label>
            <div className="w-full">
            <CustomTextarea
                rows={3}
                size="lg"
                placeholder="入力してください"
                isResizable={false}
                value={cancelReason}
                onChange={(e: any) => setCancelReason(e.target.value)}
            />
            </div>
        </div>

        <div className="flex justify-center items-center gap-8 px-6 pb-6">
          <CustomButton
            onClick={onClose}
            variant="danger_text"
          >
            キャンセル
          </CustomButton>
          <CustomButton 
            size="md"
            variant="danger"
            disabled={isSaving || !cancelReason || !cancelReason.trim()}
            onClick={handleCancelTalent}
          >
            退会する
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default CancelTalentModal;
